

import { Button, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Paper as MaterialPaper, Link, Paper, Box, InputLabel, Select, MenuItem, FormControlLabel, Checkbox, TablePagination } from '@material-ui/core';
import { Teacher } from '../../../interfaces/examiner/Teacher'
import { AuthLog } from '../../../interfaces/examiner/AuthLog'
import React, { Fragment } from 'react';
import ExaminerContainer from '../ExaminerContainer';

import '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import SavingIndicator from '../../../components/SavingIndicator';
import SaveCancelButtons from '../../../components/SaveCancelButtons';
import { Cancel, Delete } from '@material-ui/icons';
import request, { apiLoginAsTeacher, getConfigSync, isLoggedIn } from '../../../api';
import { Redirect } from 'react-router-dom';
import countryList from 'react-select-country-list'
import ExaminerTeacherExams from './ExaminerTeacherExams';
import { Exam, ExamHasTeacher } from '../../../interfaces/examiner/Exam';
import EnrolTeacherDialog from './EnrolTeacherDialog';
import IncreaseStudentsDialog from './IncreaseStudentsDialog';
import TeacherDeleteDialog from './TeacherDeleteDialog';
import LoginAsTeacherDialog from './LoginAsTeacherDialog';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { UnsavedChangesHandler } from '../../../utils/unsavedChanges';
import UnsavedChangesDialog from '../../../components/UnsavedChangesDialog';
import { examinerHasRole } from '../../../components/RoleAccess';

interface Props {
  id: string
}

interface State {
  teacher: Teacher | null,
  saving: boolean
  canReset: boolean
  enrolTeacherDialog: Exam | null
  increaseStudentsDialog: ExamHasTeacher | null
  deleteTeacherDialog: Teacher | null
  resetPasswordMessage: string | null
  hasChanges: boolean
  showUnsavedDialog: boolean
  loginAsDialogOpen: boolean
  loginAsLoading: boolean
  loginAsError: string | null
  authLogs: AuthLog[]
  authLogsTotal: number
  authLogsPage: number
  authLogsRowsPerPage: number
}

class ExaminerTeacherPage extends React.Component<Props & RouteComponentProps, State> {

  private unsavedChanges = new UnsavedChangesHandler()

  constructor(props: Props & RouteComponentProps) {

    super(props)

    this.state = {
      teacher: null,
      saving: false,
      hasChanges: false,
      canReset: true,
      enrolTeacherDialog: null,
      increaseStudentsDialog: null,
      deleteTeacherDialog:null,
      resetPasswordMessage:null,
      showUnsavedDialog: false,
      loginAsDialogOpen: false,
      loginAsLoading: false,
      loginAsError: null,
      authLogs: [],
      authLogsTotal: 0,
      authLogsPage: 0,
      authLogsRowsPerPage: 5,
    }
  }

  render() {
    let { teacher, saving, canReset, resetPasswordMessage } = this.state

    if (!isLoggedIn('examiner')) {
      return <Redirect to='/login' />
    }


    if (!teacher) {
      return <ExaminerContainer heading={"Loading..."}>Loading...</ExaminerContainer>
    }
    const options = countryList().getData()
    return (
      <ExaminerContainer heading={teacher.name + ' - ' + teacher.school + ' - ' + teacher.schoolCode}>
        <UnsavedChangesDialog
          open={this.state.showUnsavedDialog}
          onYes={this.handleUnsavedYes}
          onNo={this.handleUnsavedNo}
        />
        <SavingIndicator saving={saving} />
        {this.state.enrolTeacherDialog && <EnrolTeacherDialog onEnrolTeacher={this.onEnrolTeacher} onClose={this.onCloseEnrolTeacherDialog} exam={this.state.enrolTeacherDialog} />}
        {this.state.increaseStudentsDialog && <IncreaseStudentsDialog onAddStudents={this.onIncreaseStudents} onClose={this.onCloseIncreaseStudentsDialog} examHasTeacher={this.state.increaseStudentsDialog} />}
        {this.state.deleteTeacherDialog && <TeacherDeleteDialog teacher={this.state.deleteTeacherDialog} onClose={this.closeDeleteTeacherDialog} onDelete={this.handleDeleteTeacher} />}
        <LoginAsTeacherDialog
          teacher={teacher}
          open={this.state.loginAsDialogOpen}
          loading={this.state.loginAsLoading}
          error={this.state.loginAsError}
          onClose={this.closeLoginAsDialog}
          onConfirm={this.confirmLoginAsTeacher}
        />
        <Fragment>
          School Code: {teacher.schoolCode}
          <br />
          School Student Default Password: {teacher.defaultPassword}
          <br />
          Status: {teacher.status}
          {teacher.status === "PENDING" && (
            <span>
              {teacher.emailDomainFlagged && ' (email domain matches existing school)'}
              {teacher.schoolNameFlagged && ' (school name matches existing records)'}
            </span>
          )}
          <br />
          <>Created At: {teacher.createdAt ? new Date(teacher.createdAt).toLocaleString() : '—'}</>
          <br />
          {teacher.status === "ACTIVE" && (
            teacher.approvedAt ? (
              <>Approved At: {new Date(teacher.approvedAt).toLocaleString()}</>
            ) : (
              <>Approved At: This account was approved, but the approval time was not recorded.</>
            )
          )}
          <br /><br />
          <Button disabled={!canReset} onClick={() => this.handleResetPassword()} variant="outlined">E-mail new password</Button>
          {examinerHasRole(['admin', 'superuser']) && (
            <>
              <br /><br />
              <Button color="primary" variant="outlined" onClick={this.openLoginAsDialog}>Login as Teacher</Button>
            </>
          )}
          {teacher.status === "PENDING" && (
            <>
              <br /><br />
              <Button color="primary" variant="outlined" onClick={this.handleApprove}>Approve</Button>
              <Button style={{ marginLeft: 8 }} color="secondary" variant="outlined" onClick={this.handleReject}>Reject</Button>
            </>
          )}
          {teacher.status === "REJECTED" && (
            <>
              <br /><br />
              <Button color="primary" variant="outlined" onClick={this.handlePending}>Set Pending</Button>
            </>
          )}
          {teacher.status !== "BLOCKED" && teacher.status !== "PENDING" && teacher.status !== "REQUIRES_VERIFICATION" && (
            <>
              <br /><br />
              <Button color="secondary" variant="outlined" onClick={this.handleBlock}>Block Teacher</Button>
            </>
          )}
          {teacher.status === "BLOCKED" && (
            <>
              <br /><br />
              <Button color="primary" variant="outlined" onClick={this.handleUnblock}>Unblock Teacher</Button>
            </>
          )}
        </Fragment>
        {teacher.status === "PENDING" && (
          <Fragment>
            <br />
            <h3>Registration Form Details</h3>
            {teacher.howHeardAbout && (
              <Fragment>
                <strong>How heard about competitions:</strong> {teacher.howHeardAbout}
                {teacher.howHeardAbout === "Other" && teacher.howHeardAboutOther && (
                  <Fragment>
                    <br />
                    <strong>Details:</strong> {teacher.howHeardAboutOther}
                  </Fragment>
                )}
                <br />
              </Fragment>
            )}
            <strong>Confirm read notes:</strong> {teacher.confirmReadNotes ? 'Yes' : 'No'}
            <br />
            <strong>Confirm teacher:</strong> {teacher.confirmTeacher ? 'Yes' : 'No'}
            <br />
            <strong>Consent 1 (competitions):</strong> {teacher.consent1 === 'accept' ? 'Yes' : 'No'}
            <br />
            <strong>Consent 2 (future opportunities):</strong> {teacher.consent2 === 'accept' ? 'Yes' : 'No'}
            <br />
            {teacher.location === "Overseas" && teacher.countryName && (
              <Fragment>
                <strong>Country name:</strong> {teacher.countryName}
                <br />
              </Fragment>
            )}
            <br />
          </Fragment>
        )}
        {!canReset && resetPasswordMessage && <p>{resetPasswordMessage}</p>}
        <br />
        <br />
        <ExaminerTeacherExams exams={teacher.exams} onClickExam={this.onClickExam} />
        <br />
        <TextField margin="dense"
                   id="name" label="Name"
                   fullWidth defaultValue={teacher.name}
                   onChange={(e) => this.handleFieldChange('name', e)} />
        <TextField margin="dense"
                   id="email" label="Email"
                   fullWidth defaultValue={teacher.email}
                   onChange={(e) => this.handleFieldChange('email', e)} />
        <TextField margin="dense"
                   id="school" label="School"
                   fullWidth defaultValue={teacher.school}
                   onChange={(e) => this.handleFieldChange('school', e)} />
        <TextField margin="dense"
                   id="urn" label="URN"
                   fullWidth defaultValue={teacher.urn}
                   onChange={(e) => this.handleFieldChange('urn', e)} />
        <InputLabel id="location-label">Location</InputLabel>
        <Select
          required
          label="Location"
          value={teacher.location}
          onChange={(e) => this.handleFieldChange('location', e)}
        >
          <MenuItem
            key={"Overseas"}
            value={"Overseas"}>
            {"Overseas"}
          </MenuItem>
          <MenuItem
            key={"UK"}
            value={"UK"}>
            {"UK"}
          </MenuItem>
          {teacher.location === "Test" && (
            <MenuItem key={"Test"} value={"Test"} disabled>
              {"Test (legacy - use School Type)"}
            </MenuItem>
          )}
        </Select>
        <InputLabel id="schooltype-label">School Type</InputLabel>
        <Select
          required
          label="School Type"
          value={teacher.schoolType}
          onChange={(e) => this.handleFieldChange('schoolType', e)}
        >
          <MenuItem
            key={"Non-fee-paying"}
            value={"Non-fee-paying"}>
            {"Non-fee-paying"}
          </MenuItem>
          <MenuItem
            key={"Fee-paying"}
            value={"Fee-paying"}>
            {"Fee-paying"}
          </MenuItem>
          <MenuItem
            key={"Unspecified"}
            value={"Unspecified"}>
            {"Unspecified"}
          </MenuItem>
          <MenuItem
            key={"Test"}
            value={"Test"}>
            {"Test"}
          </MenuItem>
        </Select>
        <br />
        <FormControlLabel
          control={
            <Checkbox
              onChange={this.toggleConsent}
              checked={teacher.consent2 == "accept"}
              color="primary"
            />}
          label={`Please keep me informed about ${getConfigSync().competitionShortName} competitions`}
        />
        <br />
        <FormControlLabel
          control={
            <Checkbox
              onChange={this.toggleAuthenticated}
              checked={teacher.isAuthenticated }
              color="primary"
            />}
          label={`Allow teacher to use invoices?`}
        />
        <h3>Address</h3>
        <TextField margin="dense"
                   id="line1" label="Line 1"
                   fullWidth defaultValue={teacher.addressLine1}
                   onChange={(e) => this.handleFieldChange('addressLine1', e)} />
        <TextField margin="dense"
                   id="line2" label="Line 2"
                   fullWidth defaultValue={teacher.addressLine2}
                   onChange={(e) => this.handleFieldChange('addressLine2', e)} />
        <TextField margin="dense"
                   id="addressCity" label="City"
                   fullWidth defaultValue={teacher.addressCity}
                   onChange={(e) => this.handleFieldChange('addressCity', e)} />
        <TextField margin="dense"
                   id="addressState" label="County"
                   fullWidth defaultValue={teacher.addressState}
                   onChange={(e) => this.handleFieldChange('addressState', e)} />
        <TextField margin="dense"
                   id="addressPostcode" label="Postcode"
                   fullWidth defaultValue={teacher.addressPostcode}
                   onChange={(e) => this.handleFieldChange('addressPostcode', e)} />
        <InputLabel id="addressCountry-label">Country</InputLabel>
        <Select margin="dense"
                id="addressCountry" label="Country"
                fullWidth defaultValue={teacher.addressCountry}
                onChange={(e) => this.handleFieldChange('addressCountry', e)}>
          <MenuItem
            value={"GB"}>
            {"United Kingdom"}
          </MenuItem>
          {options.map((o, i) => {
            return (
              <MenuItem
                key={i}
                value={o.value}>
                {o.label}
              </MenuItem>
            );
          })}
        </Select>
        <TextField margin="dense"
                   id="phoneNumber" label="Telephone Number"
                   fullWidth defaultValue={teacher.phoneNumber}
                   onChange={(e) => this.handleFieldChange('phoneNumber', e)} />
        <TextField margin="dense"
                   id="website" label="Website"
                   fullWidth defaultValue={teacher.website}
                   onChange={(e) => this.handleFieldChange('website', e)} />
        <SaveCancelButtons
          onSave={this.handleSave}
          onCancel={this.handleCancel}
          saveLoading={this.state.saving}
          saveDisabled={!this.state.hasChanges}
        />
        <br />
        <br />
        <h3>Action Logs</h3>
        <Table>
          <TableRow>
            <TableCell style={{ fontWeight: "bold" }}>Time</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Action</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Comment</TableCell>
          </TableRow>
          <TableBody>
            {this.state.authLogs.map((a, index) => {
              return(
                <TableRow key={`${a.createdAt}-${a.action}-${index}`}>
                  <TableCell>{new Date(a.createdAt).toLocaleString()}</TableCell>
                  <TableCell>{a.action}</TableCell>
                  <TableCell>{a.success ? 'Success' : 'Fail'}</TableCell>
                  <TableCell>{a.comment}</TableCell>
                </TableRow>
              )})}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={this.state.authLogsTotal}
          page={this.state.authLogsPage}
          onChangePage={this.handleAuthLogsPageChange}
          rowsPerPage={this.state.authLogsRowsPerPage}
          onChangeRowsPerPage={this.handleAuthLogsRowsPerPageChange}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />

        <br />
        <br />
        <Button onClick={() => this.openDeleteTeacherDialog(teacher)}>Delete Teacher<Delete /></Button>
      </ExaminerContainer>
    )
  }

  componentDidMount() {

    this.reloadTeacher()
    this.reloadAuthLogs()

  }

  componentDidUpdate(prevProps: Props & RouteComponentProps, prevState: State) {
    if (prevState.hasChanges !== this.state.hasChanges) {
      this.unsavedChanges.setup(this.props.history, this.state.hasChanges, () => {
        this.setState(prev => ({ ...prev, showUnsavedDialog: true }))
      })
    }
  }

  componentWillUnmount() {
    this.unsavedChanges.cleanup()
  }

  private async reloadTeacher() {

    let teacher = await (await request('/api/examiner/teachers/' + this.props.id)).json()

    this.setState(prevState => ({ ...prevState, teacher }))
  }

  private async reloadAuthLogs() {
    const { authLogsPage, authLogsRowsPerPage } = this.state
    const offset = authLogsPage * authLogsRowsPerPage

    const res = await request(
      `/api/examiner/teachers/${this.props.id}/authLogs?offset=${offset}&limit=${authLogsRowsPerPage}`
    )

    if (!res.ok) {
      return
    }

    const body = await res.json()
    this.setState(prevState => ({
      ...prevState,
      authLogs: body.authLogs || [],
      authLogsTotal: body.total || 0,
    }))
  }

  handleAuthLogsPageChange = async (_event: unknown, page: number) => {
    await this.setState(prevState => ({ ...prevState, authLogsPage: page }))
    this.reloadAuthLogs()
  }

  handleAuthLogsRowsPerPageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const rowsPerPage = parseInt(event.target.value, 10)
    await this.setState(prevState => ({
      ...prevState,
      authLogsRowsPerPage: rowsPerPage,
      authLogsPage: 0,
    }))
    this.reloadAuthLogs()
  }

  async save() {
    await request('/api/examiner/teachers/' + this.props.id, {
      method: 'PUT',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(this.state.teacher)
    })
    await this.setState(prevState => ({ ...prevState, saving: false, hasChanges: false }))
  }

  handleSave = async () => {
    await this.setState(prevState => ({ ...prevState, saving: true }))
    await this.save()
  }

  handleCancel = async () => {
    // Reload the teacher data to discard changes
    await this.reloadTeacher()
    await this.setState(prevState => ({ ...prevState, hasChanges: false }))
  }

  handleFieldChange = async (field: string, e: any) => {
    let teacher = this.state.teacher as Teacher
    let newTeacher: Teacher = { ...teacher, [field]: e.target.value }

    await this.setState(prevState => ({ ...prevState, teacher: newTeacher, hasChanges: true }))
  }

  handleUnsavedYes = () => {
    this.setState(prev => ({ ...prev, showUnsavedDialog: false }))
    this.unsavedChanges.confirm(this.props.history)
  }

  handleUnsavedNo = () => {
    this.setState(prev => ({ ...prev, showUnsavedDialog: false }))
    this.unsavedChanges.cancel()
  }

  handleResetPassword = async () => {
    let message:string = await (await request('/api/examiner/teachers/' + this.props.id + '/resetPassword',
      {
        method: 'POST',
      })).text()
    let teacher = this.state.teacher
    teacher!.tempPassword = true
    this.setState(prevState => ({ ...prevState, teacher, canReset: false, resetPasswordMessage: message }))
  }

  openLoginAsDialog = () => {
    this.setState({ loginAsDialogOpen: true, loginAsError: null })
  }

  closeLoginAsDialog = () => {
    if (this.state.loginAsLoading) return
    this.setState({ loginAsDialogOpen: false, loginAsError: null })
  }

  confirmLoginAsTeacher = async () => {
    if (this.state.loginAsLoading) return

    this.setState({ loginAsLoading: true, loginAsError: null })

    const res = await apiLoginAsTeacher(this.props.id)

    if (res.error) {
      this.setState({ loginAsLoading: false, loginAsError: res.error })
      return
    }

    window.location.href = '/teacher'
  }

  handleApprove = async () => {
    try {
      let res = await request('/api/examiner/teachers/' + this.props.id + '/approve', {
        method: 'POST',
        headers: { 'content-type': 'application/json' }
      })
      if (!res.ok) {
        let errorText = await res.text()
        alert('Failed to approve teacher: ' + (errorText || 'Unknown error'))
        return
      }
      this.reloadTeacher()
    } catch (e) {
      alert('Failed to approve teacher: ' + (e.message || 'Unknown error'))
    }
  }

  handleReject = async () => {
    try {
      let res = await request('/api/examiner/teachers/' + this.props.id + '/reject', {
        method: 'POST',
        headers: { 'content-type': 'application/json' }
      })
      if (!res.ok) {
        let errorText = await res.text()
        alert('Failed to reject teacher: ' + (errorText || 'Unknown error'))
        return
      }
      this.reloadTeacher()
    } catch (e) {
      alert('Failed to reject teacher: ' + (e.message || 'Unknown error'))
    }
  }

  handlePending = async () => {
    try {
      let res = await request('/api/examiner/teachers/' + this.props.id + '/pending', {
        method: 'POST',
        headers: { 'content-type': 'application/json' }
      })
      if (!res.ok) {
        let errorText = await res.text()
        alert('Failed to set teacher to pending: ' + (errorText || 'Unknown error'))
        return
      }
      this.reloadTeacher()
    } catch (e) {
      alert('Failed to set teacher to pending: ' + (e.message || 'Unknown error'))
    }
  }

  onClickExam = (examId: string) => {
    let exam = this.state.teacher?.exams.filter(e => e.id == examId)[0]
    let enrolled = exam!.teachers.length > 0
    console.log(enrolled)
    if (enrolled) {
      this.setState(prevState => ({ ...prevState, increaseStudentsDialog: exam!.teachers[0] }))
    } else {
      this.setState(prevState => ({ ...prevState, enrolTeacherDialog: exam! }))
    }
  }

  onIncreaseStudents = async (n: number) => {
    console.log(this.state.increaseStudentsDialog!.examId, n)
    await request('/api/examiner/examHasTeacher/' + this.state.increaseStudentsDialog!.id, {
      method: 'PUT',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        n: n
      })
    })
    this.reloadTeacher()
    this.setState(prevState => ({ ...prevState, increaseStudentsDialog: null }))
  }

  onCloseIncreaseStudentsDialog = () => {
    this.setState(prevState => ({ ...prevState, increaseStudentsDialog: null }))
  }

  onEnrolTeacher = async () => {
    console.log(this.state.enrolTeacherDialog!.id)
    await request('/api/examiner/examHasTeacher', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        examId: this.state.enrolTeacherDialog!.id,
        teacherId: this.props.id
      })
    })
    this.reloadTeacher()
    this.setState(prevState => ({ ...prevState, enrolTeacherDialog: null }))
  }

  onCloseEnrolTeacherDialog = () => {
    this.setState(prevState => ({ ...prevState, enrolTeacherDialog: null }))
  }

  toggleConsent = async (event: { target: { checked: boolean; }; }) => {
    let teacher = this.state.teacher as Teacher
    let consent = ""
    if (event.target.checked) { consent = "accept" }
    let newTeacher: Teacher = { ...teacher, consent2: consent }
    await this.setState(prevState => ({ ...prevState, teacher: newTeacher, hasChanges: true }))
  }

  toggleAuthenticated = async (event: { target: { checked: boolean; }; }) => {
    let teacher = this.state.teacher as Teacher
    let newTeacher: Teacher = { ...teacher, isAuthenticated: event.target.checked }
    await this.setState(prevState => ({ ...prevState, teacher: newTeacher, hasChanges: true }))
  }

  handleDeleteTeacher = async (teacher:Teacher) => {
    await request('/api/examiner/teachers/' + teacher.id, { method: 'DELETE' })
    window.location.href = './';
  }

  closeDeleteTeacherDialog = async () => {
    await this.setState(prevState => ({ ...prevState, deleteTeacherDialog:null }))
  }

  openDeleteTeacherDialog = async (teacher:Teacher | null) => {
    await this.setState(prevState => ({ ...prevState, deleteTeacherDialog:teacher }))
  }

  handleBlock = async () => {
    if (!window.confirm(`Are you sure you want to block ${this.state.teacher?.name}? They will be prevented from enrolling in new competitions but will retain access to competitions they already participated in.`)) {
      return
    }
    try {
      let res = await request('/api/examiner/teachers/' + this.props.id + '/block', {
        method: 'POST',
        headers: { 'content-type': 'application/json' }
      })
      if (!res.ok) {
        let errorText = await res.text()
        alert('Failed to block teacher: ' + (errorText || 'Unknown error'))
        return
      }
      this.reloadTeacher()
    } catch (e) {
      alert('Failed to block teacher: ' + (e.message || 'Unknown error'))
    }
  }

  handleUnblock = async () => {
    if (!window.confirm(`Are you sure you want to unblock ${this.state.teacher?.name}?`)) {
      return
    }
    try {
      let res = await request('/api/examiner/teachers/' + this.props.id + '/unblock', {
        method: 'POST',
        headers: { 'content-type': 'application/json' }
      })
      if (!res.ok) {
        let errorText = await res.text()
        alert('Failed to unblock teacher: ' + (errorText || 'Unknown error'))
        return
      }
      this.reloadTeacher()
    } catch (e) {
      alert('Failed to unblock teacher: ' + (e.message || 'Unknown error'))
    }
  }

}

export default withRouter(ExaminerTeacherPage)
